/**
 * ScrollReveal — Animate children on scroll (IntersectionObserver + framer-motion)
 */
import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const directionMap = {
  up: { y: 40, x: 0 },
  down: { y: -40, x: 0 },
  left: { y: 0, x: -40 },
  right: { y: 0, x: 40 },
};

function ScrollReveal({
  children,
  delay = 0,
  direction = 'up',
  duration = 0.7,
  threshold = 0.15,
  style = {},
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: threshold });
  const offset = directionMap[direction] || directionMap.up;

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, x: offset.x, y: offset.y }}
      animate={isInView ? { opacity: 1, x: 0, y: 0 } : {}}
      transition={{
        duration,
        delay,
        ease: [0.25, 0.46, 0.45, 0.94],
      }}
      style={style}
    >
      {children}
    </motion.div>
  );
}

export default ScrollReveal;
